export default function getItemStyles({ width, x, y, canDropMedia }) {
  return {
    position: 'fixed',
    textAlign: 'center',
    verticalAlign: 'middle',
    width: width,
    height: width,
    background: canDropMedia ? '#72ccb3' : 'red',
    borderRadius: '50%',
    top: y + 10,
    left: x + 10,
    display: 'block',
    pointerEvents: 'none',
    boxShadow: '0 3px 6px rgba(0, 0, 0, .175)'
  }
}



// WEBPACK FOOTER //
// ./src/components/Media/DragLayer/getItemStyles.js